import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { UsPostJoinWizard } from "../../../../components/features/onboarding/us/post-join/us-post-join-wizard.tsx";
// Reuse the current public post-join page shell without changing its flow.
import styles from "../../../onboard-post-join/onboard-post-join-page.module.css";

const HERO_CARD_BG = "/assets/images/onboarding-form-card-bg.png";
export default function UsPostJoinPage() {
  const [params] = useSearchParams();
  const token = params.get("token")?.trim() ?? "";
  const [employeeName, setEmployeeName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => setEmployeeName(""), [token]);
  return <div className={styles.page} data-theme="caelius-classic">
    <header className={styles.topBar}><img className={styles.logo} src="/assets/CaeliusOne_logo.svg" alt="Caelius Consulting Logo" width={150} /></header>
    <main className={styles.main}><div className={styles.inner}>
      {!submitted && <section className={styles.heroCard} style={{ backgroundImage: `url(${HERO_CARD_BG})` }}><h1 className={styles.heroTitle}>{employeeName ? `Welcome, ${employeeName}` : "Welcome"}</h1><div className={styles.heroLine} /><p className={`body-sm ${styles.heroIntro}`}>You’re almost there! Complete your onboarding by sharing your bank details and required employment documents.</p></section>}
      {!token ? <p className={`body-sm ${styles.error}`} role="alert">Open this page with a token. For local testing use: ?token=mock-us-postjoin</p> : <UsPostJoinWizard token={token} onEmployeeVerified={setEmployeeName} onSubmitted={() => setSubmitted(true)} />}
    </div></main>
  </div>;
}

